import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const InitRadioGroup = ({
  patientParameter,
  handleChange,
  selectedValue,
  newLabel,
  labelPrefix,
}) => {
  const { t } = useTranslation();

  return (
    <RadioGroup
      aria-labelledby={`${patientParameter}-group`}
      name={`${patientParameter}-group`}
      value={selectedValue}
      defaultValue={selectedValue}
      onChange={handleChange}
    >
      <div className="w3-container">
        {patientParameter.paramRadios?.map((radioValue, i) => {
          return (
            <div className="w3-container" key={`${patientParameter}${i}`}>
              <FormControlLabel
                key={`value${i}`}
                value={radioValue}
                control={<Radio />}
                label={
                  <div className="w3-container">
                    {patientParameter.paramRadioIcons?.length > 0 && (
                      <FontAwesomeIcon icon={patientParameter.paramRadioIcons[i]} />
                    )}
                    <label className="w3-margin-left">
                      {newLabel && labelPrefix === radioValue ? newLabel  : t(radioValue)}
                    </label>
                  </div>
                }
              />
            </div>
          );
        })}
      </div>
    </RadioGroup>
  );
};

export default InitRadioGroup;
